import { render, staticRenderFns } from "./AppSectionHero.vue?vue&type=template&id=556d3b44&scoped=true"
import script from "./AppSectionHero.vue?vue&type=script&lang=js"
export * from "./AppSectionHero.vue?vue&type=script&lang=js"
import style0 from "./AppSectionHero.vue?vue&type=style&index=0&id=556d3b44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d3b44",
  null
  
)

export default component.exports